"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var PhoneVerificationWithoutForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _l = _a.closeEdited, closeEdited = _l === void 0 ? function () { } : _l;
    var t = (0, next_intl_1.useTranslations)('translation');
    var tPhone = (0, next_intl_1.useTranslations)('phoneVerification');
    var tErr = (0, next_intl_1.useTranslations)('errors');
    var data = (0, swr_hooks_1.useUser)().data;
    var countries = (0, swr_hooks_1.useCountriesOptions)();
    var _m = (0, react_1.useState)(((_e = (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.getOne) === null || _c === void 0 ? void 0 : _c.profile) === null || _d === void 0 ? void 0 : _d.contacts) === null || _e === void 0 ? void 0 : _e.phone) || undefined), phone = _m[0], setPhone = _m[1];
    var _o = (0, react_1.useState)(null), errorPhoneUpdate = _o[0], setErrorPhoneUpdate = _o[1];
    var _p = (0, swr_hooks_1.useSendPhoneVerificationSms)({}), sendPhoneVerificationSms = _p.sendPhoneVerificationSms, isSubmitting = _p.isSubmitting;
    var updateProfile = (0, swr_hooks_1.useUpdateProfileData)({
        successAction: function () {
            if (phone) {
                sendPhoneVerificationSms({
                    input: {
                        phone: phone,
                    },
                });
                closeEdited();
            }
        },
        errorAction: function (err) {
            setErrorPhoneUpdate(err);
        },
    }).updateProfile;
    var country = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = countries.find(function (item) { var _a, _b, _c, _d; return item.value === ((_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.getOne) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.location) === null || _d === void 0 ? void 0 : _d.country); })) === null || _a === void 0 ? void 0 : _a.value;
    }, [countries, (_j = (_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.profile) === null || _f === void 0 ? void 0 : _f.getOne) === null || _g === void 0 ? void 0 : _g.profile) === null || _h === void 0 ? void 0 : _h.location) === null || _j === void 0 ? void 0 : _j.country]);
    var sendVerificationCode = (0, react_1.useCallback)(function () {
        updateProfile({ phone: phone });
    }, [phone, updateProfile]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, tPhone('enterYourPhoneNumberWhereWeWillSendVerificationCode')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            closeEdited ? (react_1.default.createElement("button", { type: "button", className: styles_module_scss_1.default.close, onClick: closeEdited })) : null,
            react_1.default.createElement(ui_components_1.PhoneInput, { name: "phone", value: phone, onChange: function (newPhone) {
                    setPhone(newPhone);
                    setErrorPhoneUpdate(null);
                }, country: !phone ? (_k = String(country || '')) === null || _k === void 0 ? void 0 : _k.toLowerCase() : undefined, placeholder: t('phone'), labelText: t('phone'), tooltip: react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: t.raw('lockPersonalData'),
                    } }) }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.errorWrapper }, errorPhoneUpdate && (react_1.default.createElement(ui_components_1.ErrorText, null, tErr("".concat(errorPhoneUpdate))))),
            react_1.default.createElement(ui_components_1.FixedButton, { height: "40px", width: "100%", type: "button", text: "upper", color: "gradient", maxWidth: "none", loading: isSubmitting, disabled: !Boolean(phone) || !Boolean((phone === null || phone === void 0 ? void 0 : phone.length) && (phone === null || phone === void 0 ? void 0 : phone.length) >= 8), onClick: sendVerificationCode }, tPhone('sendVerificationCode')))));
};
exports.default = PhoneVerificationWithoutForm;
